import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { DownOutlined } from '@ant-design/icons'
import { Button, Dropdown as AntDropdown, Menu } from 'antd'

const Dropdown = ({
  mode = 'multiple',
  value,
  values,
  children = null,
  onChange,
  title,
  titlePropName = 'title',
  trigger = ['click'],
  valuePropName = 'value',
  scrollable = false
}) => {
  const [visible, setVisible] = useState(false)
  const [clickedInside, setClickedInside] = useState(false)

  const onClick = item => {
    setClickedInside(true)
    // Always use item.key since we explicitly set it in Menu.Item
    const filterProp = item.key

    // Toggle: if exists, remove; if not, add
    if (value.find(v => v === filterProp)) {
      onChange(value.filter(v => v !== filterProp))
    } else {
      onChange([...value, filterProp])
    }
  }

  const handleVisibleChange = shouldBeVisible => {
    // If we clicked inside (menu item), keep dropdown open in multiple mode
    if (clickedInside && mode === 'multiple') {
      setClickedInside(false)
      return // Don't close
    }
    setVisible(shouldBeVisible)
  }
  const menu = (
    <Menu
      style={scrollable ? { maxHeight: '300px', overflowY: 'scroll' } : null}
      multiple={mode === 'multiple'}
      onClick={onClick}
      selectedKeys={value}
    >
      {children ||
        values?.map(item => (
          <Menu.Item key={item.key} value={item[valuePropName]}>
            {item[titlePropName]}
          </Menu.Item>
        ))}
    </Menu>
  )
  return (
    <AntDropdown
      overlay={menu}
      trigger={trigger}
      open={visible}
      onOpenChange={handleVisibleChange}
      getPopupContainer={triggerNode => triggerNode.parentElement || document.body}
    >
      <Button
        onClick={e => {
          e.stopPropagation()
          setVisible(!visible)
        }}
      >
        {title}
        <DownOutlined />
      </Button>
    </AntDropdown>
  )
}
Dropdown.propTypes = {
  mode: PropTypes.oneOf(['multiple']),
  value: PropTypes.oneOfType([PropTypes.array]).isRequired,
  values: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  titlePropName: PropTypes.string,
  valuePropName: PropTypes.string,
  children: PropTypes.node,
  trigger: PropTypes.array,
  scrollable: PropTypes.bool
}

export default Dropdown
